import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import round from 'lodash/round';
import { TAB_CITY_COMPARISON } from '@/constants/job-title';
import { JOB_TITLE_PAGE_ROUTER_PATH } from '@/constants/router-path';
import { SimilarJobTitleType } from '@/context/job-title';
import { trackClickEvent } from '@/utils/site-track';

type Props = {
  city?: { name: string; pinyin?: string };
  isJobTitlePage?: boolean;
  dataEleGroup?: string;
} & SimilarJobTitleType;

const Card = ({
  id,
  name,
  salary,
  city,
  isJobTitlePage = false,
  description,
  dataEleGroup = 'card_职场薪酬',
}: Props) => {
  const router = useRouter();
  const cardName = city && city?.name ? city?.name + name : name;
  const nextPath =
    city && city?.pinyin
      ? `/${city?.pinyin}/${id}/`
      : `${JOB_TITLE_PAGE_ROUTER_PATH}${id}/`;
  const dataId = `${id}_${name}`;

  return (
    <li
      className="rounded-lg cursor-pointer items-start bg-white min-w-[155px] shadow-[0px_5px_10px_0px_rgba(0,0,0,0.05)] hover:shadow-black/[0.15]"
      onClick={(e) => {
        trackClickEvent(e);
        router.push(nextPath);
      }}
      data-observer-id={id}
      data-ele-group={dataEleGroup}
      data-ele-id={dataId}
    >
      <div className="w-full">
        <div className="px-4 pt-4">
          {isJobTitlePage ? (
            <h2 className="font-semibold leading-6 line-clamp-1">{cardName}</h2>
          ) : (
            <h4 className="font-semibold leading-6 line-clamp-1">{cardName}</h4>
          )}
          <p className="text-sm leading-5.5 text-web-blue-500 mt-2">
            {`￥${round(salary, -2)}/月`}
          </p>
          <p className="line-clamp-2 text-xs leading-[19px] text-black/65 mt-2.5">
            {description.slice(0, 40)}
          </p>
        </div>
        <div className="mt-2.5 flex flex-row justify-between p-4 pt-0 text-sm leading-5.5 text-[#0C4085] tablet:pr-10">
          <Link
            href={nextPath}
            onClick={(e) => trackClickEvent(e, true)}
            className="line-clamp-1 hover:underline"
            data-ele-group={`${dataEleGroup}_employ`}
            data-ele-id={`${dataId}_employ`}
          >
            {`${cardName}招聘`}
          </Link>
          <Link
            href={`${nextPath}#${TAB_CITY_COMPARISON}`}
            className="ml-auto whitespace-nowrap cursor-pointer hover:underline tablet:ml-3"
            onClick={(e) => {
              trackClickEvent(e, true);
            }}
            data-ele-group={`${dataEleGroup}_city`}
            data-ele-id={`${dataId}_city`}
          >
            城市对比
          </Link>
        </div>
      </div>
    </li>
  );
};
export default Card;
